import * as firebase from 'firebase'

  var firebaseConfig = {
    apiKey: "AIzaSyDVSVHB_6dN3wvPkVVz-0r-f_j3pi-P1Bc",
    authDomain: "arriba-van.firebaseapp.com",
    databaseURL: "https://arriba-van.firebaseio.com",
    projectId: "arriba-van",
    storageBucket: "",
    messagingSenderId: "364277226914",
    appId: "1:364277226914:web:c0ce977261ddd654"
  };
  // Initialize Firebase
  let fire = firebase.initializeApp(firebaseConfig);

  let auth = firebase.auth()
  let db = firebase.database();
  let fs = firebase.firestore();
  let facebook_provider = new firebase.auth.FacebookAuthProvider();
  let google_provider = new firebase.auth.GoogleAuthProvider();


  //===========================USER_AUTHENTICATION===================\\

  function userAuth_facebook(){
     return new Promise((resolve,reject)=>{
       auth.signInWithPopup(facebook_provider).then(result=>{
         console.log('result+++>>',result.user)
         let userAuth = {
           name : result.user.displayName,
           photo: result.user.photoURL,
           uid : result.user.uid,
         }
         fs.collection('userAuth').doc(result.user.uid).set(userAuth);
         console.log('userAuth_________>',userAuth)
         resolve(result)
        }).catch(e =>{
          reject(e.message)
        })
    })
  }

  function userAuth_google(){
    return new Promise((resolve,reject)=>{
      auth.signInWithPopup(google_provider).then(result=>{
        //database
        let userAuth = {
          name : result.user.displayName,
          photo: result.user.photoURL,
          uid : result.user.uid,
        }
        fs.collection('userAuth').doc(result.user.uid).set(userAuth);
        console.log('userAuth_________>',userAuth)
        resolve(result)
      }).catch(e=>{
        reject(e.message)
      })
    })
  }
//_______________________________________________USER-AUTH-END_________________________________________________________//



//________________________________________USER-REGISTRATION______________________________//
function userRegistration(data,user){
return new Promise((resolve,reject)=>{
  fs.collection('userRegistration').doc(user).set(data).then(()=>{
    fs.collection('userRegistration').doc(user).collection('routine').doc('Segunda-feira').set({Ida:true,Volta:true});
    fs.collection('userRegistration').doc(user).collection('routine').doc('Terca').set({Ida:true,Volta:true});
    fs.collection('userRegistration').doc(user).collection('routine').doc('Quarta-feira').set({Ida:true,Volta:true});
    fs.collection('userRegistration').doc(user).collection('routine').doc('Quinta-feira').set({Ida:true,Volta:true});
    fs.collection('userRegistration').doc(user).collection('routine').doc('Sexta-feira').set({Ida:true,Volta:true});
    fs.collection('userRegistration').doc(user).collection('routine').doc('Sabado').set({Ida:true,Volta:true});
    fs.collection('userRegistration').doc(user).collection('routine').doc('Domingo').set({Ida:true,Volta:true});
    resolve({message:'Registerd Successfully'})
  }).catch(e=>{
    reject({message:e.message})
  })
})
}
//______________________________________USER-REGISTRATION-END____________________________//


// _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ 


 //===========================VAN_AUTHENTICATION===================\\

 function vanAuth_facebook(){
  return new Promise((resolve,reject)=>{
    auth.signInWithPopup(facebook_provider).then(result=>{
      console.log('result+++>>',result.user)
      let userAuth = {
        name : result.user.displayName,
        photo: result.user.photoURL,
        uid : result.user.uid,
      }
      fs.collection('vanAuth').doc(result.user.uid).set(userAuth);
      console.log('userAuth_________>',userAuth)
      resolve(result)
     }).catch(e =>{
       reject(e.message)
     })
 })
}

function vanAuth_google(){
 return new Promise((resolve,reject)=>{
   auth.signInWithPopup(google_provider).then(result=>{
     //database
     let userAuth = {
      name : result.user.displayName,
      photo: result.user.photoURL,
      uid : result.user.uid,
    }
     fs.collection('vanAuth').doc(result.user.uid).set(userAuth);
     console.log('userAuth_________>',userAuth)
     resolve(result)
   }).catch(e=>{
     reject(e.message)
   })
 })
}
//_______________________________________________VAN-AUTH-END_________________________________________________________//

//________________________________________VAN-REGISTRATION______________________________//
function vanRegistration(data,user){
  return new Promise((resolve,reject)=>{
    fs.collection('vanRegistration').doc(user).set(data).then(()=>{
      fs.collection('registerdPlate').doc(user).set({plate:data.placa})
      resolve({message:'Registerd Successfully'})
    }).catch(e=>{
      reject({message:e.message})
    })
  })
  }
  //______________________________________VAN-REGISTRATION-END____________________________//
  

export {
  userAuth_facebook,
  userAuth_google,
  fire,
  userRegistration,
  vanAuth_facebook,
  vanAuth_google,
  vanRegistration,
}